<!-- Button -->
<button
    mat-icon-button
    [matMenuTriggerFor]="userActions">
    <span class="relative">
        <img
            class="max-w-7 max-h-7 object-cover rounded-full"
            *ngIf="showAvatar && user?.avatar"
            [src]="user?.avatar">
        <mat-icon
            *ngIf="!showAvatar || !user?.avatar"
            [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span
            *ngIf="user"
            class="absolute right-0 bottom-0 w-2 h-2 rounded-full"
            [ngClass]="{'mr-px mb-px': !showAvatar || !user?.avatar,
                          'bg-green-500': user?.status === 'online',
                          'bg-amber-500': user?.status === 'away',
                          'bg-red-500': user?.status === 'busy',
                          'bg-gray-400': user?.status === 'not-visible'}"></span>
    </span>
</button>

<mat-menu
    class="user-actions-menu"
    [xPosition]="'before'"
    #userActions="matMenu"
    (closed)="onUserMenuClosed()">
    <ng-container *ngIf="!layoutPickerOpen">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span *ngIf="!e.user.impersonator">Signed in as</span>
            <span *ngIf="e.user.impersonator">Impersonating</span>
            <span class="mt-1.5 text-md font-semibold">{{e.user.profile?.fullname}}</span>
            <span class="mt-1 text-sm text-secondary">{{e.user.profile?.email}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>

    <button *ngIf="workspaceSwitcherMode === 'organizations'"
        mat-menu-item
        [matMenuTriggerFor]="userOrganization">
        <mat-icon [svgIcon]="'heroicons_outline:office-building'"></mat-icon>
        <span *ngIf="!selectedOrganization" class="ml-auto text-sm">
            Select an Organization and a Branch
        </span>
        <span *ngIf="selectedOrganization" class="ml-auto text-sm">
            {{selectedOrganization.name}}
            <span *ngIf="selectedBranch"> / {{selectedBranch.name}}</span>
        </span>
    </button>

    <button *ngIf="workspaceSwitcherMode === 'branches'"
        mat-menu-item
        [matMenuTriggerFor]="branchOnlyMenu">
        <mat-icon [svgIcon]="'heroicons_outline:library'"></mat-icon>
        <span class="ml-auto text-sm">
            <span *ngIf="switcherOrganization">{{ switcherOrganization.name }}</span>
            <span *ngIf="switcherOrganization && selectedBranch"> / </span>
            <span *ngIf="selectedBranch">{{ selectedBranch.name }}</span>
            <span *ngIf="!selectedBranch">Select a branch</span>
        </span>
    </button>

    <mat-divider *ngIf="showWorkspaceSwitcher" class="my-2"></mat-divider>

    <button
        mat-menu-item
        [routerLink]="['/profile']">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Profile</span>
    </button>

    <div
        class="user-menu-scheme"
        role="menuitem"
        (click)="$event.stopPropagation()">
        <div class="user-menu-scheme-left">
            <mat-icon
                class="user-menu-scheme-icon"
                [svgIcon]="darkMode ? 'heroicons_solid:moon' : 'heroicons_solid:sun'"></mat-icon>
            <span class="user-menu-scheme-label">Dark mode</span>
        </div>
        <mat-slide-toggle
            class="user-menu-scheme-switch"
            [checked]="darkMode"
            (change)="onDarkModeChange($event.checked)"
            (click)="$event.stopPropagation()"
            color="primary"
            aria-label="Toggle dark mode"></mat-slide-toggle>
    </div>

    <a
        *ngIf="showDocumentation"
        mat-menu-item
        href="/documentation"
        target="_blank"
        rel="noopener">
        <mat-icon [svgIcon]="'heroicons_outline:book-open'"></mat-icon>
        <span>Documentation</span>
    </a>

    <!-- <button
        mat-menu-item
        [routerLink]="['/settings']">
        <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>
        <span>Settings</span>
    </button> -->
    <!-- <button *ngIf="canManageUsers"
        mat-menu-item
        [routerLink]="['/users']">
        <mat-icon [svgIcon]="'heroicons_outline:users'"></mat-icon>
        <span>Users</span>
    </button> -->
    <!-- <button
        mat-menu-item
        [matMenuTriggerFor]="userStatus">
        <mat-icon [svgIcon]="'heroicons_outline:dots-circle-horizontal'"></mat-icon>
        <span>Status</span>
    </button> -->

    <div
        *ngIf="showLayoutPicker"
        class="user-menu-layout"
        role="menuitem"
        (click)="openLayoutPicker($event)">
        <mat-icon class="user-menu-layout-icon" [svgIcon]="'heroicons_outline:view-grid'"></mat-icon>
        <span class="user-menu-layout-label">Layout</span>
        <span class="user-menu-layout-value">{{ currentLayoutLabel }}</span>
        <mat-icon class="user-menu-layout-chevron" [svgIcon]="'heroicons_outline:chevron-right'"></mat-icon>
    </div>

    <mat-divider class="my-2"></mat-divider>
    <button
        mat-menu-item
        (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
        <span>Sign out</span>
    </button>
    <button
        *ngIf="impersonating"
        mat-menu-item
        (click)="unimpersonate()">
        <mat-icon [svgIcon]="'heroicons_outline:reply'"></mat-icon>
        <span>Unimpersonate</span>
    </button>
    </ng-container>

    <ng-container *ngIf="layoutPickerOpen">
        <button
            mat-menu-item
            class="user-menu-layout-back"
            (click)="closeLayoutPicker($event)">
            <mat-icon [svgIcon]="'heroicons_outline:chevron-left'"></mat-icon>
            <span>Layout</span>
        </button>
        <mat-divider class="my-2"></mat-divider>
        <button
            mat-menu-item
            *ngFor="let option of layoutOptions"
            (click)="setLayout(option.id)"
            [class.bg-gray-100]="currentLayout === option.id">
            <span [class.text-primary]="currentLayout === option.id">{{ option.label }}</span>
        </button>
    </ng-container>
</mat-menu>

<!-- <mat-menu
    class="user-status-menu"
    #userStatus="matMenu">
    <button
        mat-menu-item
        (click)="updateUserStatus('online')">
        <span class="w-4 h-4 mr-3 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('away')">
        <span class="w-4 h-4 mr-3 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('busy')">
        <span class="w-4 h-4 mr-3 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('not-visible')">
        <span class="w-4 h-4 mr-3 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu> -->

<mat-menu
    class="user-organization-menu"
    #userOrganization="matMenu">
    <ng-container *ngFor="let organization of organizations">
        <button
            *ngIf="organizationNeedsBranchSubmenu(organization)"
            mat-menu-item
            [matMenuTriggerFor]="branchesSubmenu"
            (mouseenter)="setHoveredOrganization(organization)"
            (click)="selectOrganization(organization)"
            [class.bg-gray-100]="selectedOrganization?.code === organization.code">
            <mat-icon [svgIcon]="'heroicons_outline:office-building'"></mat-icon>
            <span [class.text-primary]="selectedOrganization?.code === organization.code">{{organization.name}}</span>
        </button>
        <button
            *ngIf="!organizationNeedsBranchSubmenu(organization)"
            mat-menu-item
            (click)="selectOrganization(organization)"
            [class.bg-gray-100]="selectedOrganization?.code === organization.code">
            <mat-icon [svgIcon]="'heroicons_outline:office-building'"></mat-icon>
            <span [class.text-primary]="selectedOrganization?.code === organization.code">{{organization.name}}</span>
        </button>
    </ng-container>
</mat-menu>

<mat-menu
    class="user-branch-menu"
    #branchOnlyMenu="matMenu">
    <button
        mat-menu-item
        *ngFor="let branch of switcherBranches"
        (click)="selectBranch(branch, switcherOrganization)"
        [class.bg-gray-100]="selectedBranch?.code === branch.code">
        <mat-icon [svgIcon]="'heroicons_outline:library'"></mat-icon>
        <span [class.text-primary]="selectedBranch?.code === branch.code">{{branch.name}}</span>
    </button>
</mat-menu>

<mat-menu
    class="user-branch-menu"
    #branchesSubmenu="matMenu">
    <button
        mat-menu-item
        *ngFor="let branch of hoveredOrganization?.branches"
        (click)="selectBranch(branch, hoveredOrganization)"
        [class.bg-gray-100]="selectedBranch?.code === branch.code && selectedOrganization?.code === hoveredOrganization?.code">
        <mat-icon [svgIcon]="'heroicons_outline:library'"></mat-icon>
        <span [class.text-primary]="selectedBranch?.code === branch.code && selectedOrganization?.code === hoveredOrganization?.code">{{branch.name}}</span>
    </button>
    <div *ngIf="!hoveredOrganization?.branches || hoveredOrganization.branches.length === 0" class="px-4 py-2 text-sm text-gray-500">
        No branches available
    </div>
</mat-menu>


